<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="userInfo.avatar" />
        </div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.nickname }}</div>
            <!-- <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />
              {{ userInfo.vip_name }}
            </div> -->
          </div>
          <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
            ID：{{ userInfo.uid || 0 }}
            <span class="iconfont icon-bianji1"></span>
          </router-link>
          <router-link :to="'/user/bill/0'" class="binding" v-else>
            <span>我的余额:{{ userInfo.now_money || 0 }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/myOrder/orderList/1'" class="allOrder">
            全部订单
            <span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/myOrder/orderList/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unPay && orderStatusNum.unPay > 0"
                >{{ orderStatusNum.unPay }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/myOrder/orderList/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span class="order-status-num" v-if="orderStatusNum.hasPay > 0">{{
                orderStatusNum.hasPay
              }}</span>
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/myOrder/orderList/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span class="order-status-num" v-if="orderStatusNum.ship > 0">{{
                orderStatusNum.ship
              }}</span>
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/myOrder/orderList/' + 4 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.complete > 0"
                >{{ orderStatusNum.complete }}</span
              >
            </div>
            <div>已完成</div>
          </router-link>
        </div>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的收货单</div>
          <router-link :to="'/myOrder/dispatchList/0'" class="allOrder">
            全部收货单
            <span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link
            :to="{ path: '/myOrder/dispatchList/' + 1 }"
            class="item"
          >
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span class="order-status-num" v-if="shipStatusNum.ship > 0">{{
                shipStatusNum.ship
              }}</span>
            </div>
            <div>待收货</div>
          </router-link>
          <router-link
            :to="{ path: '/myOrder/dispatchList/' + 2 }"
            class="item"
          >
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="shipStatusNum.complete > 0"
                >{{ shipStatusNum.complete }}</span
              >
            </div>
            <div>已收货</div>
          </router-link>
        </div>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的售后单</div>
          <router-link :to="'/myOrder/serviceOrder/1'" class="allOrder">
            全部售后单
            <span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <!-- <router-link :to="{ path: '/myOrder/serviceOrder/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
              >{{ orderStatusNum.unpaid_count }}</span>
            </div>
            <div>待受理</div>
          </router-link> -->
          <router-link
            :to="{ path: '/myOrder/serviceOrder/' + 1 }"
            class="item"
          >
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span class="order-status-num" v-if="afterStatusNum.ship > 0">{{
                afterStatusNum.ship
              }}</span>
            </div>
            <div>受理中</div>
          </router-link>
          <router-link
            :to="{ path: '/myOrder/serviceOrder/' + 2 }"
            class="item"
          >
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="afterStatusNum.complete > 1"
                >{{ afterStatusNum.complete }}</span
              >
            </div>
            <div>已受理</div>
          </router-link>
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {
        unPay: 0
      },
      shipStatusNum: {},
      afterStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    // this.User();
    // this.MenuUser();
    // this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.saleOrderStatusNum
          ? res.data.saleOrderStatusNum
          : "";
        that.shipStatusNum = res.data.saleOrderShipStatusNum
          ? res.data.saleOrderShipStatusNum
          : "";
        that.afterStatusNum = res.data.saleAfterStatusNum
          ? res.data.saleAfterStatusNum
          : "";
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1.2rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
